import React from 'react'
import { SvgIcon } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton"
import "./Header.css"
import PersonIcon from '@material-ui/icons/Person';
import ForumIcon from '@material-ui/icons/Forum';
import {Link, useHistory} from "react-router-dom";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

function Header({backButton}) {
    //give us the browser session history
    const history= useHistory();

    return (
        <div className="header">
            {backButton ? (
                <IconButton onClick={()=>history.replace(backButton)}>
                <ArrowBackIosIcon fontSize="large" className="header__icon"/>
                </IconButton>
            ): (
                <IconButton>
                <PersonIcon className="header__icon" fontSize="large"/>
                </IconButton>
    
            )}
            
           
            <Link to ="/">
            <img className="header__logo"
             src="https://1000logos.net/wp-content/uploads/2018/07/tinder-logo.png" alt=""/>
            </Link>

            <Link to ="/chat">
            <IconButton>
            <ForumIcon className="header__icon" fontSize="large"/>
            </IconButton>
            </Link>
            </div>
           

          
    )
}

export default Header
